import {BasicObject} from '@components/types';
import {useRoute} from '@react-navigation/native';
import {useEffect, useState} from 'react';
import {getGameCategory} from '@/pages/casino/casino-service';
const TOTAL_VALUE = 'Lobby';
export function useGameType() {
  const {params} = useRoute();
  const homeGameType = (params as BasicObject)?.gameType;
  const [gameType, setGameType] = useState<string>(TOTAL_VALUE);
  const [gameTypes, setGameTypes] = useState<{label: string; value: string}[]>(
    [],
  );
  const getGameCategories = () => {
    getGameCategory('casino').then(res => {
      const gamesList = res.map(v => {
        return {
          label: v.name,
          value: v.id,
        };
      });
      setGameTypes([{label: TOTAL_VALUE, value: TOTAL_VALUE}, ...gamesList]);
    });
  };
  useEffect(() => {
    if (homeGameType && gameTypes.length > 0) {
      const cur = gameTypes.find(item =>
        item.label.toLowerCase().includes(homeGameType.toLowerCase()),
      );
      setGameType(cur?.value || TOTAL_VALUE);
    } else {
      setGameType(TOTAL_VALUE);
    }
  }, [homeGameType, gameTypes]);
  useEffect(() => {
    getGameCategories();
  }, []);
  return {
    gameTypes,
    gameType,
    setGameType,
  };
}
